export var getApp = {
  computed: {
    getApp () {
      let el = this.$root.$children[0]
      return el
    }
  }
}
